
import "bootstrap/dist/css/bootstrap.min.css";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
const Navbar = () => {
    const {t, i18n } = useTranslation();
    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
        document.documentElement.dir = lang === "he" ? "rtl" : "ltr";
    };

  return (
    <nav className="navbar navbar-expand-lg navbar-light border-bottom ms-auto" dir="rtl">
      <div className="container-fluid">
        <div className="btn-group" dir="ltr">
            <button
                className={`btn btn-sm ${i18n.language==="en"?"btn-secondary":"btn-outline-secondary"}`}
                onClick={() => changeLanguage("en")}
            >
                English
            </button>
            <button
                className={`btn btn-sm ${i18n.language==="he"?"btn-secondary":"btn-outline-secondary"}`}
                onClick={() => changeLanguage("he")}
            >
                 עִבְרִית
            </button>

        </div>
        <span className="navbar-brand fw-bold">
            <img
                src="/logo192.png"   // תשני לנתיב הלוגו שלך
                alt="Israel Kitchen logo"
                className="logo-small me-2"
                style={{ width: "70px",
                        height: "70px",
                        objectFit: "cover",
                        borderRadius: "50%"}}
            />
        {t("israel_kitchen")}
        </span>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarMenu"
        >
          <span className="navbar-toggler-icon"></span>
        </button>


<div className="collapse navbar-collapse" id="navbarMenu">
  <ul className="navbar-nav mb-2 mb-lg-0 me-auto gap-3">
             <li className="nav-item">
      <NavLink className={({ isActive }) =>
    isActive ? "nav-link active-link fw-bold" : "nav-link"
  } to="/events">{t("events")}</NavLink>
    </li>
    <li className="nav-item">
      <NavLink className={({ isActive }) =>
    isActive ? "nav-link active-link fw-bold" : "nav-link"
  } to="/gallery"> {t("gallery")} </NavLink>
    </li>
    <li className="nav-item">
      <NavLink className={({ isActive }) =>
    isActive ? "nav-link active-link fw-bold" : "nav-link"
  } to="/about">{t("about_me")}</NavLink>
    </li>
      <li className="nav-item">
      <NavLink className={({ isActive }) =>
    isActive ? "nav-link active-link fw-bold" : "nav-link"
  } to="/">{t("menu_title")}</NavLink>
    </li>

  </ul>
</div>
      </div>
    </nav>
  );
};

export default Navbar;
